module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "none",
      "background": "rgba(255, 255, 255, 0.7)",
      "z-index": "1000"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "top": "50%",
      "left": "50%",
      "position": "absolute",
      "font-size": "30px"
    }
  })]), _vm._v(" "), (_vm.telaProjeto && _vm.definicoes.length === 0) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "publico-alvo-previsto-container"
  }, [_c('div', {
    staticClass: "publico-alvo-descritivo"
  }, [_vm._v("\n      Descrição de Público-alvo.\n      "), (!_vm.editar && _vm.permiteEditar && !_vm.telaProjeto) ? _c('g-button-moema', {
    staticClass: "botao-editar-publico",
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleEdicao(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        Alterar")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "column start-centered publico-alvo-table-container"
  }, [_c('div', {
    staticClass: "publico-alvo-subtitulo"
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Público-alvo "), _c('b', [_vm._v("previsto")]), _vm._v(" cadastrado (" + _vm._s(_vm.itemTable.length) + "):\n      ")]), _vm._v(" "), (!_vm.editar) ? _c('b-container', {
    staticClass: "publico-alvo-table",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    key: _vm.tableDataKey,
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "fields": _vm.table.fields,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "filter": _vm.table.filter,
      "empty-text": "Nenhum registro encontrado",
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "publico",
      fn: function(row) {
        return [_c('b', [_vm._v(_vm._s(row.value))])]
      }
    }, {
      key: "tipo",
      fn: function(row) {
        return [_c('div', {
          attrs: {
            "title": row.item.descricao
          }
        }, [_vm._v("\n                        " + _vm._s(row.value) + "\n                      ")])]
      }
    }], null, false, 3855842344)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.editar) ? _c('div', {
    staticClass: "publico-alvo-content"
  }, [_c('div', {
    staticClass: "publico-alvo-definicao-container"
  }, _vm._l((_vm.definicaoPublicoAlvo), function(item, index) {
    return (!(item.tipo === 'Sociedade em geral' && _vm.telaParticipante)) ? _c('div', {
      staticClass: "publico-alvo-item-container",
      class: {
        'adjust-height': item.aberto
      },
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          return _vm.toogleItem(index)
        }
      }
    }, [_c('div', {
      staticClass: "publico-alvo-titulo",
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          return _vm.toogleItem(index)
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(item.tipo))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-caret-right",
      class: {
        'rotate-icon': item.aberto
      },
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), (item.aberto) ? _c('div', {
      staticClass: "divider",
      class: {
        'show-item': item.aberto
      }
    }) : _vm._e(), _vm._v(" "), (item.aberto) ? _c('div', {
      staticClass: "publico-alvo-content-container"
    }, _vm._l((item.subgrupos), function(detalhamento) {
      return (item.aberto) ? _c('div', {
        staticClass: "publico-alvo-items",
        class: {
          'show-item': item.aberto
        },
        attrs: {
          "title": detalhamento.descricao
        }
      }, [_c('label', {
        staticClass: "conjunto-item"
      }, [_vm._v("\n                " + _vm._s(detalhamento.subgrupo) + " "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (detalhamento.selecionado),
          expression: "detalhamento.selecionado"
        }],
        staticClass: "publico-check",
        attrs: {
          "disabled": !_vm.editar,
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(detalhamento.selecionado) ? _vm._i(detalhamento.selecionado, null) > -1 : (detalhamento.selecionado)
        },
        on: {
          "change": [function($event) {
            var $$a = detalhamento.selecionado,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(detalhamento, "selecionado", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(detalhamento, "selecionado", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(detalhamento, "selecionado", $$c)
            }
          }, function($event) {
            return _vm.updateSelecao(detalhamento.id, detalhamento.selecionado, item.tipo)
          }]
        }
      })])]) : _vm._e()
    }), 0) : _vm._e()]) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "publico-alvo-acoes-container"
  }, [(_vm.editar && !_vm.telaParticipante) ? _c('g-button-moema', {
    attrs: {
      "color": "error",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleEdicao(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar Edição")]) : _vm._e(), _vm._v(" "), (_vm.editar && !_vm.telaParticipante) ? _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.limparSelecao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Limpar")]) : _vm._e(), _vm._v(" "), (_vm.editar && !_vm.telaParticipante) ? _c('g-button-moema', {
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvarSelecao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        Salvar")]) : _vm._e()], 1)]), _vm._v(" "), _c('vue-snotify')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publico-alvo-descritivo"
  }, [_vm._v("Sem dados cadastrados de público-alvo "), _c('strong', [_vm._v("previsto")]), _vm._v(".")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ff571e30!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/publicoAlvoDescricaoProposta.vue
// module id = 2108
// module chunks = 1